import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { Table } from "elemental-react16"
import Price from "components/Price/Price"
import { observer } from "mobx-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore";
import CouponInput  from "components/Cart/CouponInput";
import { withRouter, Link } from "react-router-dom"
import { act } from "react"
import Responsive from "react-responsive"

@observer
class CartTotal extends Component {
  
  componentDidMount() {
    shop.cart.update()
  }
  
  render() {
    let { sum, size, showTax, fluid, className = "", activeStep } = this.props
    let {  brutto, tax, sumDiscount } = shop.cart
    let discountSum = shop.cart.data.sum
    let discountVat = shop.cart.data.vat
    console.log("discountSum",discountSum, "discountVat",discountVat)
    let couponsActivated = shop.cart.activeCoupons && shop.cart.activeCoupons[0]

    if (tax === 0){
      tax = sum * 0.19
      brutto = sum + tax
    }
    console.log("fluid",fluid, "brutto",brutto, "tax",tax, "sumDiscount",sumDiscount, "sum",sum, "size",size, "activeStep",activeStep, shop.cart.data, shop.cart.activeCoupons[0])
    return (
      <Table style={{ maxWidth: `${fluid ? "100%" : "320px"}`, border: "none" }} className={`CartTotalCheckout ${className} `}>
      <thead>
      {cmsStore.config.plugin.coupons && (activeStep === 0 || activeStep === 100) &&
      <tr>
        <td colSpan={2}>
        <CouponInput/>
        </td>
      </tr>}
      
      <tr >
        <td style={{minWidth: "260px", maxWidth: "260px", width: "260px"}}><strong>{translate( "Positionen:" )}</strong></td>
        <td className="tr">{size}</td>
      </tr>
      
      <tr>
        <td style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "cartfooter.nettosum" )}</strong></td>
        <td className="cartTotalCheckout pr2">
          {couponsActivated && activeStep !== 3 ? <Fragment><span className="strike black-60"><Price>{activeStep == 99 ? brutto - tax : sum}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{activeStep == 99 ? brutto - tax : discountSum}</Price></span></Fragment> : <Price>{activeStep == 99 ? brutto - tax : sum}</Price>}</td>
      </tr>
      {shop.session && shop.session.value && shop.session.value.country === "D" && <Fragment><tr> {/*activeStep == 2 &&  */}
        <td style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "cartfooter.addvat" )}</strong></td>
        <td  className="cartTotalCheckout pr2">
          {couponsActivated && activeStep !== 3 ? <Fragment><span className="strike black-60"><Price>{tax}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{discountVat}</Price></span></Fragment> : <Price>{tax}</Price>}</td>
      </tr>
          <tr>
        <td  style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "cartfooter.bruttosum" )} </strong></td>
        <td className="cartTotalCheckout pr2">
          {couponsActivated && activeStep !== 3 ? <Fragment><span className="strike black-60"><Price>{activeStep == 99 ? brutto : Number(sum)+Number(tax)}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{activeStep == 99 ? brutto : Number(discountSum)+Number(discountVat)}</Price></span></Fragment> : <Price>{activeStep == 99 ? brutto : Number(sum)+Number(tax)}</Price>}</td>
      </tr></Fragment>}
      
      {showTax &&
      <tr>
        <td><strong>{translate( "MwSt." )}</strong></td>
        <td style={{
        direction: "ltr",
        textAlign: "left",
        whiteSpace: "nowrap",
        overflow: "visible"
        }} className="tr"><Price>{tax}</Price></td>
      </tr>
      }
      
      {shop.config.useTaxNotice && <tr>
        <td colSpan={2}>
        <shop.config.useTaxNotice/>
        </td>
      </tr>}
      
      {showTax &&
      <tr>
        <td><strong>{translate( "Brutto" )}</strong></td>
        <td style={{
        direction: "ltr",
        textAlign: "right",
        whiteSpace: "nowrap",
        overflow: "visible"
        }} className="tr"><Price>{brutto}</Price></td>
      </tr>
      }
      
      
      {(shop.session.handId && !!sumDiscount) &&
      <React.Fragment>
        <tr className={"black-60 f5"}>
        <td>{translate( "Discount" )}</td>
        <td style={{
          direction: "ltr",
          textAlign: "right",
          whiteSpace: "nowrap",
          overflow: "visible"
        }} className="tr"><Price>{sumDiscount}</Price></td>
        </tr>
        
        <tr>
        <td><strong>{translate( "nach Rabatt" )}</strong></td>
        <td style={{
          direction: "ltr",
          textAlign: "right",
          whiteSpace: "nowrap",
          overflow: "visible"
        }} className="tr"><Price>{sum - sumDiscount}</Price></td>
        </tr>
      </React.Fragment>
      }
      
      </thead>
      </Table>
    )
  }
}

CartTotal.propTypes = {
  sum : PropTypes.number,
  size: PropTypes.number,
}

export default CartTotal



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Cart/CartTotal.js